export default {
    setProfileId(state, id) {
        state.memberId = id;
    },
    setEntityId(state, id) {
        state.entityId = id;
    },
    getProfileSections(state, payload) {
        // state.profileSections = payload
    },

    getProfileOptions(state, options) {
        state.profileOptions = options
    },

    getProfile(state, profile) {
        state.profileState = profile
    },

    updateAvatar(state, payload) {
        state.profileState.profile_photo_large = payload
    },

    saveBasicInfo(state, user) {
        state.profileState = user
    },

    removeConfirmation(state, { removeableItemSlug, removeableItemStateKey, data }) {
        var removeableItemState;
        if ( removeableItemStateKey === 'contactPhoneState' ||
            removeableItemStateKey === 'contactEmailState' ||
            removeableItemStateKey === 'contactAddressState' )
        {
            removeableItemState = state.contact[removeableItemStateKey]
        } else {
            removeableItemState = state[removeableItemSlug][removeableItemStateKey]
        }

        removeableItemState.splice(removeableItemState.indexOf(data), 1);
    }
}



// WEBPACK FOOTER //
// ./src/store/profile/_mutations.js